/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import * as actionTypes from '../constants/action-types';
import { AnyAction } from 'redux';
import { OnboardingToken } from '../types/onboarding';
import { ReduxReducer } from './index';


interface StateNotLoaded extends ReduxReducer<Partial<OnboardingToken>> {
  loaded: false;
}

interface StateLoaded extends ReduxReducer<OnboardingToken> {
  loaded: true;
}


const onboardingToken = (
  state: StateLoaded | StateNotLoaded = {
    data: {},
    loaded: false,
    errored: false,
    errorMessage: ''
  },
  action: AnyAction
) => {

  const lastUpdated = Date.now();
  switch (action.type) {

    case actionTypes.LOADING_ONBOARDING_TOKEN:
      return { ...state, data: {}, loaded: false, errored: false, lastUpdated };
    case actionTypes.LOADED_ONBOARDING_TOKEN:
      return { ...state, data: action.data, loaded: true, errored: false, lastUpdated };
    case actionTypes.ERROR_ONBOARDING_TOKEN:
      return { ...state, data: {}, loaded: false, errored: true, lastUpdated };
    default:
      return state;
  }
}

export default onboardingToken;
